
<template>
  <div class="social-share" :class="location">
    <!-- <p class="short-prompt has-text-primary" style="font-weight:bold">share!</p> -->
    <p v-if="label" class="prompt title is-4"  style="padding-bottom:00px;" :style="labelColor ? 'color:' + labelColor + ' !important' : 'color:black'">{{label}}</p>
    <div class="" >
        <!-- <p style="margin-bottom:10px;">The more the merrier! Share with your bicycle traveling friends:</p> -->
    <twitter-button
    v-bind:url="currentURL"
    v-bind:shareUrl="currentURL"
    v-bind:shareDescription = "headerText + ' | Share and discover bike travel stories at BikeSleepBike.com.'"
    v-bind:isBlank="false"
    class="share-button--circle"
    btnText
    
  />
  <facebook-button
    v-bind:url="currentURL"
    v-bind:shareUrl="currentURL"
    v-bind:shareDescription = "headerText + ' | Share and discover bike travel stories at BikeSleepBike.com.'"
    v-bind:isBlank="false"
    class="share-button--circle"
    btnText
  />
  <reddit-button
    v-bind:url="currentURL"
    v-bind:shareUrl="currentURL"
    v-bind:shareDescription = "headerText + ' | Share and discover bike travel stories at BikeSleepBike.com.'"
    v-bind:isBlank="false"
    class="share-button--circle"
    btnText
  />
  <pinterest-button
    v-bind:url="currentURL"
    v-bind:shareUrl="currentURL"
    v-bind:shareDescription = "headerText + ' | Share and discover bike travel stories at BikeSleepBike.com.'"
    v-bind:isBlank="false"
    class="share-button--circle"
    btnText
  />
    </div>
  </div>
</template>

<script>
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
import RedditButton from "vue-share-buttons/src/components/RedditButton";
import PinterestButton from "vue-share-buttons/src/components/PinterestButton";


// Vue.use(TwitterButton);
export default {
  name: 'SocialSharePrompt',
  components: {TwitterButton, FacebookButton, RedditButton, PinterestButton},
  props: ['headerText', 'location', 'label', 'labelColor'],
  data () {
    return {
      currentURL: ''
        // filteredHeading:filteredHeading
        // headerText: headerText
    }
  },
  watch: {
    $route(to, from) {
      // console.log("route changed ");
      // console.log(to);
      this.getCurrentURL();
    }
  },
  methods: {
      getCurrentURL() {
        // console.log(this.$route.path.indexOf('#'));
          this.currentURL = "https://bikesleepbike.com" + this.$route.path;
      }
  },
  mounted() {
    this.getCurrentURL();
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width:1150px) {
  .social-share.side {
    position: fixed;
    right: 0;
    top: 25vh;
    padding: 5px;
    background: none;
  }
  .social-share.side button {
    display:block;
  }
  .social-share.side .prompt {
    display:none;
  }
  .social-share.side .short-prompt {
    display:block;
    max-width:50px;
    line-height: 18px;
  }

}

@media screen and (max-width:1150px) {
  .social-share.side {
    display:none;
  }
}

  .social-share {
    /* position: fixed;
    left: 0;
    top: 50vh; */

    /* display:none; */
    /* background: white; */
    padding: 20px;
    margin-top:50px;
  }

  .social-share .short-prompt {
    display:none;
  }

</style>






// WEBPACK FOOTER //
// src/components/SocialSharePrompt.vue